import api from './api';
import { SUBJECT_TOPICS } from '../config/Config';

const endpoint = SUBJECT_TOPICS;

export const subjectTopicService = {
  list: async () => {
    return api.get(endpoint);
  },
  create: async (data) => {
    return api.post(endpoint, data);
  },
  update: async (id, data) => {
    return api.patch(`${endpoint}${id}/`, data);
  },
  remove: async (id) => {
    return api.delete(`${endpoint}${id}/`);
  }
};
